// Axios
import axios from "src/lib/axios"

// --------------------------------------------|| TICKETS - SERVICES || -------------------------------------------

const getTicketList = filter => {
  return axios.get("/api/v1/ticket/getTicketList", {
    params: filter
  })
}

const insertTicket = data => {
  return axios.post("/api/v1/ticket/insertTicket", data)
}

const getTicketInfo = id => {
  return axios.get("/api/v1/ticket/getTicketById", {
    params: {
      Id: id
    }
  })
}

const ticketServices = { getTicketList, insertTicket, getTicketInfo }

export default ticketServices
